module.exports = __webpack_public_path__ + "static/media/ChangEFactoryESTA0001_design_clean_v002.4da2cdfd.webp";